<template>
  <a-form-item label="问卷中文名称">
    <a-input v-model="form.name" />
  </a-form-item>
</template>

<script>
export default {
  props: ['form'],
};
</script>